<template>
  <div class="col-sm-6 col-lg-4 my-3 px-2 text-center bloco_icon">
    <router-link :to="link_montado" class="d-block d-sm-block bloco_link placeholder-glow p-0" :title="titulo">
      <div class="img-fluid img-thumbnail d-block zoomimg d-flex" :style="['background-image: url(' + img_montada + ')']" :class="class_placeholder">
        <div class="spinner-border text-primary mt-5" v-if="img_load" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>

        <p class="titulo text-decoration-none mt-auto text-start">
          <span class="redator">
            por: {{ redator }} <br>
          </span>
          {{ short_titulo }}
        </p>
      </div>
      <div class="row align-items-end">

        <div class="row descricao">
          <small class="col-12 fs-bold ps-4 text-start"><strong>{{ sub_titulo }}</strong> </small>
          <small class="col-12 short_descr ps-4 text-start" :class="class_placeholder" v-html="short_descr"></small>
          <small class="col-12 short_descr_cat align-bottom text-end" :class="class_placeholder">Categoria: {{ categoria }} </small>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { limita_caracteres } from '@/assets/js/functions';
import { removerTags } from '@/assets/js/functions';
export default {
  name: "BlocoNoticias",
  props: {
    img_noticia: {
      default: null
    },
    titulo: {
      default: ''
    },
    sub_titulo: {
      default: ''
    },
    categoria: {
      default: ''
    },
    descricao: {
      default: ''
    },
    link: {
      default: ''
    },
    redator: {
      default: ''
    },
    ativa_placeholder: {
      default: false
    },
  },
  data() {
    return {
      img_load: true,
    }
  },
  components: {},
  computed: {
    short_descr: function () {
      let regex = /(<([^>]+)>)/ig;

      // this.descricao = removerTags(this.descricao)
      if (this.descricao.length > 200) {
        return limita_caracteres(this.descricao.replace(regex, ""), 200) + '...'
      } else {
        return this.descricao
      }
    },
    short_titulo: function () {
      try {
        var qtd_tit = this.titulo.length
        if (qtd_tit > 30) {
          return limita_caracteres(this.titulo, 30) + '...'
        } else {
          return this.titulo
        }
      } catch (error) {
        return this.titulo
      }
    },
    img_montada: function () {
      if (this.img_noticia) {
        return this.$site + '/img/news/' + this.img_noticia
      } else {
        return this.$site + '/img/logo.png'
      }
      this.img_load = false
    },
    link_montado: function () {
      return '/noticias/lnk/' + this.link
    },
    class_placeholder: function () {
      return (this.ativa_placeholder ? 'placeholder' : '');
    }
  },
  mounted() {
    this.img_load = false
    this.img_montada
  },
};
</script>

<style scoped>
p {
  display: block;
}

.bloco_link {
  background-color: var(--cor-base-texto);
  color: #FFF;
  border-radius: 0px;
  border: 0px;
  height: 400px;
  text-decoration: none;
}

/* .bloco_link:hover {
  background-color: var(--cor-base-texto);
  color: #CCC;
  transition: all 500ms ease;
} */

.bloco_icon {
  font-size: 1.3rem;
}

.titulo span {
  font-size: 0.6rem;
}

/* .titulo a {
  text-decoration: none !important;
} */

.titulo {
  font-size: 1.2rem;
  font-weight: bold;
  color: #FFF;
  width: calc(100% + 200px) !important;
  padding-left: 8px;
  padding-top: 20px;
  padding-bottom: 10px;
  margin-bottom: 0px;
  margin-right: -5px;
  margin-left: -4px !important;
  border-radius: 0px !important;
  background-color: var(--cor-base-fundo-transp);
}

.short_descr {
  font-size: 11px;
}

.short_descr_cat {
  font-size: 11px;
  color: #FFF;
  padding: 8px;
  margin-bottom: 0px;
}

.descricao {
  padding: 8px;
}

/* .imagem_thumb {
  max-height: 120px;
} */
.imagem_thumb {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 170px;
  transition: all .5s ease;
  position: relative;
  display: inline-block;
}

/* .imagem_thumb:hover {
  transition: all .5s ease;

  background-size: 150%;
} */

/* .imagem_thumb:hover:after {
  opacity: 1;
} */

.zoomimg {
  display: inline-block;
  width: 100%;
  height: 70%;
  padding: 0px 5px 0px 5px;
  background-size: cover;
  object-fit: contain;
  background-repeat: no-repeat;
  background-position: center center;
  transition: all .5s ease;
  border-radius: 0px !important;
  /* position: relative; */
}

/* .zoomimg:hover {
  cursor: pointer;
  transform: scale(0.95);
  transition: all .5s ease;
} */

</style>